import { Box, Breadcrumbs, Grid2, Link, Typography } from '@mui/material'
import React from 'react';


interface PageHeaderProps {
    children?: any;
    breadcrumbs?: BreadcrumbsModel[];
    title?: string;
}

export interface BreadcrumbsModel {
    name: string,
    route?: string,
}

const PageHeader: React.FC<PageHeaderProps> = ({ children, breadcrumbs, title }) => {


    return (
        <Box className="page-header-wrap">
            <Grid2 container>
                <Grid2 size={6}>
                    <Typography variant='h6' margin={0} fontWeight={600} color={"#000000"}>
                        {title}
                    </Typography>
                    {!!breadcrumbs && (
                        <Breadcrumbs >
                            {breadcrumbs?.map((res: BreadcrumbsModel) =>
                                <Link
                                    key={res?.name}
                                    sx={{
                                        fontSize: "14px",
                                        color: !!res?.route ? "#606060" : "#000",
                                        fontWeight: 500
                                    }}
                                    underline="none" color="inherit" href={res?.route}>
                                    {res?.name}
                                </Link>)}
                        </Breadcrumbs>
                    )}

                </Grid2>
                <Grid2 size={6}>
                    <Box sx={{ display: "flex", justifyContent: "end" }}>
                        {children}
                    </Box>
                </Grid2>
            </Grid2>
        </Box>
    )
}


export default PageHeader